import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";
import { LayoutToolbarHeight } from "../../common-styles";

const sidebarStyle = (theme: Theme) => createStyles({

    "@global": {
        // Adicionado na tag [body] quando o menu flutuante estiver vis�vel.
        ".menuOpen": {
            "& .content": {
                marginLeft: 260
            }
        }
    },


    drawerPaper: {
        position: 'fixed',
        top: LayoutToolbarHeight,
        height: "calc(100% - " + LayoutToolbarHeight + "px)",
        left: 0,
        width: 80,
        overflow: "hidden",
        backgroundColor: theme.palette.primary.dark
    },

    drawerPaper2: {
        position: 'fixed',
        top: LayoutToolbarHeight,
        height: "calc(100% - " + LayoutToolbarHeight + "px)",
        left: 80,
        width: 180,
        backgroundColor: "#fff",
        overflow: "hidden",
    },

    hide: { display: "none" },
    show: { display: "" },

    background: {
        position: "absolute",
        zIndex: 1,
        height: "100%",
        width: "100%",
        display: "block",
        top: "0",
        left: "0",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        "&:after": {
            position: "absolute",
            zIndex: 3,
            width: "100%",
            height: "100%",
            content: '""',
            display: "block",
            background: "#000",
            opacity: .8
        }
    },

    list: {
        paddingLeft: "0",
        paddingTop: "0",
        paddingBottom: "0",
        marginBottom: "8px",
        listStyle: "none",
        position: "unset",
    },

    listItem: {
        fontSize: "20px",
        paddingLeft: "24px",
        paddingRigth: "24px",
        borderLeft: "solid 4px transparent",
        height: "32px"
    },

    listItemSingle: {
        paddingLeft: "0",
        paddingTop: "0",
        paddingBottom: "0",
        listStyle: "none",
        position: "unset",
    },

    floatListItem: {
        width: "auto",
        height: "32px",
        transition: "all 300ms linear",
        position: "relative",
        backgroundColor: "transparent",
    },

    floatIcon: {
        color: theme.genie.icon.action.color
    },

    floatIconLeftWrapper: {
        marginRight: "4px",
        marginLeft: "4px",
        minWidth: "1.25em",
        justifyContent: "center"
    },

    floatIconRightWrapper: {
        marginRight: "4px",
        marginLeft: "0px",
        minWidth: "inherit",
    },

    floatTextColor: {
        color: theme.genie.sideMenu.textColor
    },

    floatActiveItem: {
        backgroundColor: theme.genie.sideMenu.floatBackgroundColor,
        "&:hover": {
            backgroundColor: theme.genie.sideMenu.floatBackgroundColor,
        }
    },


    subHeader: {
        fontSize: "0.875rem",
        paddingTop: "18px",
        paddingLeft: "4px",
        paddingRight: "4px",
        color: theme.genie.sideMenu.textColor,
        fontWeight: "bold",
        textTransform: "uppercase",
        lineHeight: "24px",
        "& a, & a:visited": {
            color: "inherit",
            fontWeight: "normal"
        }
    },

    notifications: {
        position: "absolute",
        top: "10px",
        right: "12px",
        fontSize: "9px",
    },

    navlinkItem: {
        position: "relative",
        display: "block",
        textDecoration: "none",
        "&:hover,&:focus,&:visited,&": {
            color: "#FFFFFF"
        }
    },

    activeRoute: {
        borderLeftColor: theme.genie.sideMenu.borderLeftColor,
        backgroundColor: theme.genie.sideMenu.backgroundColor,
        "&:hover,&:focus,&:visited,&": {
            backgroundColor: theme.genie.sideMenu.backgroundColor
        }
    },

    activeRouteText: {
        color: theme.genie.sideMenu.activeTextColor
    },

    activeParcialRouteText: {
        color: theme.genie.sideMenu.floatParcialRouteTextColor,
    },


    prependSpacer: {
        marginTop: "20px"
    },

    azDivider: {
        marginTop: 4,
        marginLeft: 4,
        marginRight: 8,
        borderBottom: "solid 1px #808080"
    }
});

export default sidebarStyle;
